import { VPagination } from 'vuetify/lib/components/VPagination';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pagination && _vm.pagination_length > 1)?_c('div',[_c(VPagination,{attrs:{"color":"blue-grey darken-4","length":_vm.pagination_length,"total-visible":"6"},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }